import rootReducer from './redux-saga/reducers/rootReducer';
import rootSagas from './redux-saga/sagas/rootSagas';

export default function getGoalsModule() {
  return {
    id: 'GOALS',
    reducerMap: {
      GOALS: rootReducer,
    },
    sagas: [rootSagas],
  };
}
